import { Auth, getAuth } from 'firebase/auth';
import { useFirebaseApp } from './useFirebaseApp';

export const useFirebaseAuth = (): Auth => {
	return getAuth(useFirebaseApp());
};
